// noinspection JSCheckFunctionSignatures

import Form from './hh-form.vue'
import Button from './hh-btn.vue'
import Checkbox from './hh-checkbox.vue'
import Currency from './hh-currency.vue'
import Email from './hh-email.vue'
import Group from './hh-form-group.vue'
import Label from './hh-label.vue'
import Numberbox from './hh-number.vue'
import Password from './hh-password.vue'
import Radio from './hh-radio.vue'
import Recaptcha from './hh-recaptcha.vue'
import RecaptchaInvisible from './hh-recaptcha-invisible.vue'
import SelectList from './hh-select.vue'
import TelephoneNumber from './hh-tel.vue'
import Textbox from './hh-textbox.vue'
import Validator from './hh-validator.vue'
import YesNo from './hh-yes-no.vue'

import Vue from 'vue'

Vue.component('hh-form', Form)
Vue.component('hh-btn', Button)
Vue.component('hh-checkbox', Checkbox)
Vue.component('hh-currency', Currency)
Vue.component('hh-email', Email)
Vue.component('hh-form-group', Group)
Vue.component('hh-label', Label)
Vue.component('hh-radio', Radio)
Vue.component('hh-recaptcha', Recaptcha)
Vue.component('hh-recaptcha-invisible', RecaptchaInvisible)
Vue.component('hh-number', Numberbox)
Vue.component('hh-password', Password)
Vue.component('hh-select', SelectList)
Vue.component('hh-tel', TelephoneNumber)
Vue.component('hh-textbox', Textbox)
Vue.component('hh-validator', Validator)
Vue.component('hh-yes-no', YesNo)

export default {
    Form,
    Button,
    Checkbox,
    Currency,
    Email,
    Group,
    Label,
    Numberbox,
    Password,
    Radio,
    Recaptcha,
    RecaptchaInvisible,
    SelectList,
    TelephoneNumber,
    Textbox,
    Validator,
    YesNo,
}
